
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/story/[id]/chapter/[chapterId]",
      function () {
        return require("private-next-pages/story/[id]/chapter/[chapterId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/story/[id]/chapter/[chapterId]"])
      });
    }
  